export const getAppProducts = () => {
    const productNameMap = {
        'no.vg.snarvei.subscription.daily': 'Daglig',
        'no.vg.snarvei.subscription.weekly': 'Ukentlig',
        'no.vg.snarvei.subscription.monthly': 'Månedlig',
        'no.vg.snarvei.subscription.quarterly': 'Kvartalsvis',
        'no.vg.snarvei.subscription.yearly': 'Årlig',
    };

    return window.iap.map((product) => {
        const productName = productNameMap[product.productId] || 'VG+';
        const fullProduct = { ...product };
        fullProduct.id = product.productId;
        fullProduct.title = productName;
        fullProduct.price = String(Number(product.price));
        fullProduct.buyButtonText = 'Kjøp';

        return fullProduct;
    });
};

export const isInAppPurchaseEnabled = () => window.iap;

export const getPaymentUrl = (id, campaignId, paymentUrlTemplate) =>
    paymentUrlTemplate
        .replace('{{PRODUCT_ID}}', id ? `&product_id=${id}` : '')
        .replace('{{APP_PRODUCT_ID}}', id ? `&productId=${id}` : '')
        .replace('{{CAMPAIGN_ID}}', campaignId ? `&campaign_id=${campaignId}` : '');

export const addPaymentUrl = (products, paymentUrlTemplate) =>
    products.map((product) => {
        const { id, campaignId } = product;
        const paymentUrl = getPaymentUrl(id, campaignId, paymentUrlTemplate);

        return { ...product, paymentUrl };
    });

export const getHeaderConfig = (headerConfig, paymentUrlTemplate) => {
    if (!headerConfig || !headerConfig.id) {
        return {};
    }

    const { id, campaignId, image, alt } = headerConfig;
    const paymentUrl = getPaymentUrl(id, campaignId, paymentUrlTemplate);

    return { image, alt, paymentUrl };
};



/** WEBPACK FOOTER **
 ** ./src/utils/subscription-helper.js
 **/